// Sends a player the server says is logged out to the log-in page. Already on
// it (with or without a locale prefix), it stays put rather than reload the page.
export default function sendToLogIn(target = window) {
	if(/^(\/[a-z]{2}(-[A-Za-z]+)?)?\/log-in\/?$/.test(target.location.pathname)) {
		return;
	}
	target.location.assign(`${target.siteUrl || ''}/log-in`);
}
